import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    flex-direction: column;
`
export const OverContainer = styled(Box)`
    width: 96%;
    justify-content: center;
    align-items: start;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: row;
        justify-content: space-between;
    }
`

export const SectionTitle = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: start;
    line-height: 32px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.white};
    padding-bottom: 20px;
    width: 98%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 885px;
    }
`
export const SectionTwo = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: start;
    line-height: 32px;
    width: 98%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.white};
    padding-bottom: 20px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 285px;
    }
`
export const SectionBlog = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 885px;
    }
`
export const CardBlog = styled(Box)`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SectionProfile = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 285px;
    }
`
